<template>
  <v-row class="content pa-5">
    <v-col cols="6" class="d-flex justify-center">
      <v-simple-table dense>
        <template v-slot:default>
          <tbody>
            <tr v-for="(el, i) in data.selected" :key="el">
              <td>{{ i }}</td>
              <td>{{ el }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-col>
    <v-col
      cols="6"
      class="d-flex justify-center flex-wrap"
      style="height: 100%;"
    >
      <h3 v-if="data.images.length <= 0">
        No hay imágenes de este vehículo
      </h3>

      <div v-else v-for="img in data.images" :key="img.id" class="d-flex">
        <v-img
          :src="img.image"
          :lazy-src="img.image"
          aspect-ratio="1"
          max-height="350"
          max-width="350"
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ["data"]
};
</script>
